
export enum CanvasAgentResponseApiModelRecurrenceTimingIntervalEnum {
    DAILY = 'Daily',
    WEEKLY = 'Weekly',
    MONTHLY = 'Monthly',
    QUARTERLY = 'Quarterly'
}
